import Status from '../enums/status';
import moment from 'moment-timezone';
import { isEmpty, get, last } from 'lodash';

const getWaitingTime = (item, seconds, timezone) => {
  const { statusInfo } = item;
  const lastCallHistory = last(get(item, 'callHistory', []) || []);
  const called = get(lastCallHistory, 'date', '') || '';
  const secondsToAdd = seconds
    ? parseInt(seconds) + 3 // Force 3 seconds extra for 23:59:59 issue on join to line
    : 0;

  const hourFrom = called ? moment(called) : (
    secondsToAdd ? moment().tz(timezone).add(secondsToAdd, 'seconds').format() : moment()
  );

  const hourTo = moment(get(item, 'checkIn.checkInTime', get(item, 'subscriptionTime', '')));

  return statusNotAllowed(statusInfo)
    ? setZeroToTimer(hourTo)
    : getDifferenceTime(hourFrom, hourTo);
}

const getDifferenceTime = (from, to) => {
  const difference = moment.duration(moment(from).diff(moment(to)));
  return moment().set({
    hour: difference.hours(),
    minute: difference.minutes(),
    second: difference.seconds(),
  }).toDate();
}

const statusNotAllowed = (statusInfo) => {
  const displayName = statusInfo.displayName;

  return [
    Status.displayNames.Expired,
    Status.displayNames.Unsubscribe,
    Status.displayNames.Requeued,
  ].some((item) => item === displayName) || (
    displayName === Status.displayNames.Canceled && 
    statusInfo.reason === Status.canceledEnum.Agenda
  );
};

const setZeroToTimer = (timer) => {
  timer.set({hour:0,minute:0,second:0,millisecond:0});
  timer.toISOString();
  return timer.format();
}

const restartTimer = (place) => {
  let timer = moment().tz(place.timezone);
  return setZeroToTimer(timer);
}

module.exports = {
  getWaitingTime,
  getDifferenceTime,
  statusNotAllowed,
  setZeroToTimer,
  restartTimer,
};
